import React from 'react';
import styled from 'styled-components';
import { colors, fontSize, fontWeight } from '../../style/tokens';
import { RiskLevel } from './ceIndicatorGroups';

interface CeIndicatorRowProps {
  label: string;
  value: string;
  risk?: RiskLevel;
  /** When provided, the whole row becomes a button that opens the detail page. */
  onClick?: () => void;
}

const Row = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 0;
  border-bottom: 1px solid #f5f5f5;
  &:last-child { border-bottom: none; }
  ${({ $clickable }) => $clickable && `
    cursor: pointer;
    @media (hover: hover) { &:hover { opacity: 0.75; } }
  `}
`;

const Label = styled.span`
  font-size: ${fontSize.base};
  color: ${colors.muted};
  font-weight: ${fontWeight.medium};
`;

const Value = styled.span<{ $risk?: RiskLevel }>`
  font-size: ${fontSize.base};
  font-weight: ${fontWeight.bold};
  color: ${({ $risk }) =>
    $risk === 'high' ? '#e53935' :
    $risk === 'medium' ? '#f9a825' :
    $risk === 'low' ? '#43a047' :
    colors.text};
`;

const CeIndicatorRow: React.FC<CeIndicatorRowProps> = ({ label, value, risk, onClick }) => (
  <Row
    $clickable={!!onClick}
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={onClick ? (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); }
    } : undefined}
  >
    <Label>{label}</Label>
    <Value $risk={risk}>{value}</Value>
  </Row>
);

export default CeIndicatorRow;
